export const extUserCognitoConfig = {
    clientId: '46rq1umuqqpn853o47e53bpfn3',
    domain: 'circles-externals.auth.eu-west-1.amazoncognito.com',
};
